import {metadaApi} from '@dms/api/base';

import {
  PostHyundaiMobisIrisReportApiResponse,
  PostHyundaiMobisIrisReportApiArg,
  PostHyundaiMobisIrisReportApiArgSchema,
  PostHyundaiMobisIrisReportApiResponseSchema,
  PostMercedesMraReportApiResponse,
  PostMercedesMraReportApiArg,
  PostMercedesMraReportApiArgSchema,
  PostMercedesMraReportApiResponseSchema,
  PostMercedesMraInactiveReportApiResponse,
  PostMercedesMraInactiveReportApiArg,
  PostMercedesMraInactiveReportApiArgSchema,
  PostMercedesMraInactiveReportApiResponseSchema,
  Post5StarReportApiResponse,
  Post5StarReportApiArg,
  Post5StarReportApiResponseSchema,
  Post5StarReportApiArgSchema,
  Get5StarCstarBranchesApiResponse,
  Get5StarCstarBranchesApiArg,
  Get5StarCstarBranchesApiArgSchema,
  Get5StarCstarBranchesApiResponseSchema,
} from './types';

export const metadaReportApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postHyundaiMobisIrisReport: build.mutation<
      PostHyundaiMobisIrisReportApiResponse,
      PostHyundaiMobisIrisReportApiArg
    >({
      query: (queryArg) => ({
        url: `/report/v1/hyundai-mobis-iris/report`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: PostHyundaiMobisIrisReportApiArgSchema,
        responseSchema: PostHyundaiMobisIrisReportApiResponseSchema,
      },
    }),
    postMercedesMraReport: build.mutation<
      PostMercedesMraReportApiResponse,
      PostMercedesMraReportApiArg
    >({
      query: (queryArg) => ({
        url: `/report/v1/invoices/save`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: PostMercedesMraReportApiArgSchema,
        responseSchema: PostMercedesMraReportApiResponseSchema,
      },
    }),
    postMercedesMraInactiveReport: build.mutation<
      PostMercedesMraInactiveReportApiResponse,
      PostMercedesMraInactiveReportApiArg
    >({
      query: (queryArg) => ({
        url: `/report/v1/inactive-notification/save`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: PostMercedesMraInactiveReportApiArgSchema,
        responseSchema: PostMercedesMraInactiveReportApiResponseSchema,
      },
    }),
    post5StarReport: build.mutation<Post5StarReportApiResponse, Post5StarReportApiArg>({
      query: (queryArg) => ({
        url: `/service/v1/5star/get-file`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: Post5StarReportApiArgSchema,
        responseSchema: Post5StarReportApiResponseSchema,
      },
    }),
    get5StarCstarBranches: build.query<
      Get5StarCstarBranchesApiResponse,
      Get5StarCstarBranchesApiArg
    >({
      query: (queryArg) => ({
        url: `/report/v1/${queryArg.type}/branches`,
        method: 'GET',
      }),
      extraOptions: {
        requestSchema: Get5StarCstarBranchesApiArgSchema,
        responseSchema: Get5StarCstarBranchesApiResponseSchema,
      },
    }),
  }),
});

export const {
  usePostHyundaiMobisIrisReportMutation,
  usePostMercedesMraReportMutation,
  usePostMercedesMraInactiveReportMutation,
  usePost5StarReportMutation,
  useGet5StarCstarBranchesQuery,
} = metadaReportApi;
